// Routes del módulo expenses. Cada tab del sidebar mapea a una vista.
// El registry expenses (registry.tsx) declara los tabs:
//   /m/expenses/list      → Tabla filtrable + recibos
//   /m/expenses/create    → Formulario de captura + upload de recibo
//   /m/expenses/dashboard → MTD/YTD por categoría vs invoicing

import { useState } from 'react';

import { ExpenseForm } from './components/ExpenseForm';
import { ExpenseList } from './components/ExpenseList';
import { ExpensesDashboard } from './components/ExpensesDashboard';

export function ExpensesListView() {
  const [refreshKey, setRefreshKey] = useState(0);
  return (
    <div className="space-y-4 p-4">
      <div className="flex items-center justify-between">
        <h1 className="text-xl font-semibold">Gastos</h1>
        <button
          type="button"
          onClick={() => setRefreshKey((k) => k + 1)}
          className="text-xs underline"
        >
          Refrescar
        </button>
      </div>
      <ExpenseList key={refreshKey} />
    </div>
  );
}

export function ExpensesCreateView() {
  const [refreshKey, setRefreshKey] = useState(0);
  return (
    <div className="space-y-4 p-4">
      <h1 className="text-xl font-semibold">Registrar nuevo gasto</h1>
      <ExpenseForm key={refreshKey} onCreated={() => setRefreshKey((k) => k + 1)} />
    </div>
  );
}

export function ExpensesDashboardView() {
  return (
    <div className="space-y-4 p-4">
      <h1 className="text-xl font-semibold">Dashboard de Gastos</h1>
      <p className="text-sm text-neutral-600">
        Cuentas por pagar vs ingresos cobrados. Lectura solo del módulo
        invoicing.
      </p>
      <ExpensesDashboard />
    </div>
  );
}
